import { SvgAsset, type TSvgAssetProps } from '../../components/svgAsset/SvgAsset';

const InvoiceAmount = (props: TSvgAssetProps) => (
  <SvgAsset width="18" height="18" viewBox="0 0 18 18" fill="none" {...props}>
    <path
      d="M9 1.5H1.5V9L8.4675 15.9675C9.1725 16.6725 10.3275 16.6725 11.0325 15.9675L15.9675 11.0325C16.6725 10.3275 16.6725 9.1725 15.9675 8.4675L9 1.5Z"
      stroke="#335DA3"
      strokeWidth="0.9375"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M5.25 5.25H5.2575" stroke="#335DA3" strokeWidth="0.9375" strokeLinecap="round" strokeLinejoin="round" />
  </SvgAsset>
);

export default InvoiceAmount;
